import { GlButton, GlFormCheckbox, GlLink, GlSprintf } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { mergeUrlParams, removeParams } from '~/lib/utils/url_utility';
import { I18N, REMEMBER_ME_PARAM } from '../constants';
export default {
    name: 'SamlAuthorize',
    components: {
        GlButton,
        GlFormCheckbox,
        GlLink,
        GlSprintf
    },
    i18n: I18N,
    inject: [
        'groupName',
        'groupUrl',
        'rememberable',
        'samlUrl',
        'signInButtonText'
    ],
    data () {
        return {
            href: this.samlUrl
        };
    },
    methods: {
        onChange (remember) {
            if (remember) {
                this.href = mergeUrlParams({
                    [REMEMBER_ME_PARAM]: '1'
                }, this.href);
            } else {
                this.href = removeParams([
                    REMEMBER_ME_PARAM
                ], this.href);
            }
        }
    }
};
